import { Page, Content } from '@backstage/core-components';
import {
  HomePageStarredEntities,
  HomePageTopVisited,
  HomePageRecentlyVisited,
} from '@backstage/plugin-home';
import myLogoLight from './Logo_white.png'; // Light-Mode-Logo
import myLogoDark from './Logo_camel.png';   // Dark-Mode-Logo
import { HomePageSearchBar } from '@backstage/plugin-search';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import { Grid, makeStyles, useTheme } from '@material-ui/core'; // useTheme importiert
import {
  NewAnnouncementBanner,
  AnnouncementsTimeline,
  AnnouncementsCard,
} from '@backstage-community/plugin-announcements';

import { DevQuote } from '@parsifal-m/plugin-dev-quotes-homepage';

const useStyles = makeStyles(theme => ({
  searchBarInput: {
    maxWidth: '60vw',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '50px',
    boxShadow: theme.shadows[1],
  },
  searchBarOutline: {
    borderStyle: 'none',
  },
}));

export const HomePage = () => {
  const classes = useStyles();
  const theme = useTheme(); // Aktuelles Theme abfragen

  // Dynamisch das Logo basierend auf dem Theme auswählen
  const logo = theme.palette.type === 'light' ?  myLogoDark : myLogoLight ;

  return (
    <SearchContextProvider>
      <Page themeId="home">
        <Content>
          <Grid container justifyContent="center" spacing={2}>
            <NewAnnouncementBanner variant='floating' />
            <img
              src={logo}
              alt="HUGO BOSS X Backstage Logo"
              style={{
                height: '70px', 
                width: 'auto', 
              }}
            />
          <Grid item md={10} xs={12}>
            <DevQuote />
          </Grid>
            <Grid container item xs={12} justifyContent="center">
              <HomePageSearchBar
                InputProps={{
                  classes: {
                    root: classes.searchBarInput,
                    notchedOutline: classes.searchBarOutline,
                  },
                }}
                placeholder="Search"
              />
            </Grid>
            <Grid container item xs={12}>
              <Grid item xs={12} md={6}>
                <HomePageTopVisited />
              </Grid>
              <Grid item xs={12} md={6}>
                <HomePageRecentlyVisited />
              </Grid>
            </Grid>
            <Grid container item xs={12}>
              <Grid item xs={12} md={6}>
                <AnnouncementsCard />
              </Grid>
              <Grid item xs={12} md={6}>
                <AnnouncementsTimeline sortBy='start_at'  timelineAlignment='left' maxResults={5}/>
              </Grid>
            </Grid>
            <Grid container item xs={12}>
              <Grid item xs={12} md={6}>
                <HomePageStarredEntities />
              </Grid>
            </Grid>
          </Grid>
        </Content>
      </Page>
    </SearchContextProvider>
  );
};